// delta2-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{arg1} registro(s) atualizado(s) automaticamente": "%{arg1} registro(s) actualizado(s) automáticamente",
    "%{arg1} registro(s) substituído(s) pela planilha": "%{arg1} registro(s) sustituido(s) por la planilla",
    "%{arg1}/%{arg2} atingido%{arg3}": "%{arg1}/%{arg2} alcanzado%{arg3}",
    "(não cadastrado).": "(no registrado).",
    "... e mais %{arg1} linha(s).": "... y %{arg1} línea(s) más.",
    "0 0 8px rgba(102,126,234,0.3)": "0 0 8px rgba(102,126,234,0.3)",
    "0 2px 12px rgba(0,0,0,0.08)": "0 2px 12px rgba(0,0,0,0.08)",
    "0 2px 8px rgba(0,0,0,.5)": "0 2px 8px rgba(0,0,0,.5)",
    "0 4px 24px rgba(0,0,0,0.4)": "0 4px 24px rgba(0,0,0,0.4)",
    "0.62rem": "0.62rem",
    "0.65rem": "0.65rem",
    "0.875rem": "0.875rem",
    "0.88rem": "0.88rem",
    "0.8rem": "0.8rem",
    "0.95rem": "0.95rem",
    "1 aviso": "1 aviso",
    "1.25rem": "1.25rem",
    "1px 6px": "1px 6px",
    "1px dashed": "1px dashed",
    "1px dashed rgba(255,255,255,.45)": "1px dashed rgba(255,255,255,.45)",
    "1px solid #e0e0e0": "1px solid #e0e0e0",
    "1px solid #ef4444": "1px solid #ef4444",
    "1px solid rgba(255,255,255,0.07)": "1px solid rgba(255,255,255,0.07)",
    "1rem": "1rem",
    "2px": "2px",
    "2px dashed rgba(255,255,255,.5)": "2px dashed rgba(255,255,255,.5)",
    "2px solid #667eea": "2px solid #667eea",
    "5px": "5px",
    "Adicione essa coluna na planilha (ou use nosso modelo) e tente de novo.": "Agregue esa columna a la planilla (o use nuestra plantilla) e intente de nuevo.",
    "Adicione essas colunas na planilha (ou use nosso modelo) e tente de novo.": "Agregue esas columnas a la planilla (o use nuestra plantilla) e intente de nuevo.",
    "Apenas não lidas": "Solo no leídas",
    "Bolão inativo": "Quiniela inactiva",
    "Bomba %{arg1} · %{arg2}": "Surtidor %{arg1} · %{arg2}",
    "CNY": "CNY",
    "Café expresso": "Café expreso",
    "Calibragem": "Calibración",
    "Captura": "Captura",
    "Clique em IMPORTAR para concluir.": "Haga clic en IMPORTAR para concluir.",
    "Confirmar": "Confirmar",
    "Código externo": "Código externo",
    "Deve ser <= kickoff": "Debe ser <= kickoff",
    "Disponível na loja": "Disponible en la tienda",
    "Enviada, não liberada": "Enviada, no liberada",
    "Enviar imagem": "Enviar imagen",
    "Escreva o que mudar primeiro": "Escriba qué cambiar primero",
    "Esta rede não tem grupo nenhum pra migrar.": "Esta red no tiene ningún grupo para migrar.",
    "Gerando…": "Generando…",
    "Lavagem simples": "Lavado simple",
    "Linha %{arg1}: %{arg2}": "Línea %{arg1}: %{arg2}",
    "Meta atingida! 🏆": "¡Objetivo alcanzado! 🏆",
    "Migrando…": "Migrando…",
    "Migrar": "Migrar",
    "Monitoramento de Quadro": "Monitoreo de Tablero",
    "Nenhum frentista encontrado": "Ningún playero encontrado",
    "Nenhum posto cadastrado nesta rede": "Ninguna estación registrada en esta red",
    "Nenhum quadro disponível para esta data/posto": "Ningún tablero disponible para esta fecha/estación",
    "Nenhuma opção encontrada": "Ninguna opción encontrada",
    "Nunca verificado": "Nunca verificado",
    "Não editável após ativação": "No editable después de la activación",
    "Não foi possível carregar os postos": "No fue posible cargar las estaciones",
    "O bolão (e o resultado) deixa de aparecer no aplicativo. Os prêmios e cupons já entregues aos clientes são mantidos — não há estorno. Você pode reativar depois.": "La quiniela (y el resultado) deja de aparecer en la aplicación. Los premios y cupones ya entregados a los clientes se mantienen — no hay reversión. Puede reactivarla después.",
    "O bolão deixa de aparecer no aplicativo e para de dar direito a palpite em novos abastecimentos. Palpites já registrados são mantidos. Você pode reativar depois.": "La quiniela deja de aparecer en la aplicación y deja de dar derecho a pronóstico en nuevas cargas de combustible. Los pronósticos ya registrados se mantienen. Puede reactivarla después.",
    "O bolão volta a aparecer no aplicativo com o resultado já processado. Não reabre para palpites e não reprocessa prêmios.": "La quiniela vuelve a aparecer en la aplicación con el resultado ya procesado. No se reabre para pronósticos ni reprocesa premios.",
    "O bolão volta a aparecer no aplicativo e a aceitar palpites. Se o prazo para palpitar já tiver passado, ele será fechado automaticamente em instantes.": "La quiniela vuelve a aparecer en la aplicación y a aceptar pronósticos. Si el plazo para pronosticar ya venció, se cerrará automáticamente en instantes.",
    "O valor %{arg1} é o mais alto em uso no momento.": "El valor %{arg1} es el más alto en uso en este momento.",
    "Os códigos vêm do mapa de pista do posto.": "Los códigos vienen del mapa de playa de la estación.",
    "Preparando…": "Preparando…",
    "Rodada %{arg1}": "Ronda %{arg1}",
    "Selecione um posto primeiro": "Seleccione una estación primero",
    "Sem filtro": "Sin filtro",
    "Testar agora": "Probar ahora",
    "Testar de novo": "Probar de nuevo",
    "Times e datas só podem ser editados em rascunho.": "Los equipos y las fechas solo se pueden editar en borrador.",
    "Troca de óleo": "Cambio de aceite",
    "Trocar imagem": "Cambiar imagen",
    "Você tem %{arg1} mensagens não lidas": "Tiene %{arg1} mensajes no leídos",
    "a rede mandou %{arg1}": "la red envió %{arg1}",
    "a rede não tem cor no cadastro — obrigatória": "la red no tiene color en el registro — obligatorio",
    "action.active": "action.active",
    "all 0.2s ease": "all 0.2s ease",
    "banner": "banner",
    "baseline": "baseline",
    "calc(100vh - 200px)": "calc(100vh - 200px)",
    "cents": "cents",
    "com o resultado.": "con el resultado.",
    "contain": "contain",
    "cpf: %{arg1} | nome: %{arg2} | identificação: %{arg3}": "cpf: %{arg1} | nombre: %{arg2} | identificación: %{arg3}",
    "daily": "daily",
    "e aceitar palpites.": "y aceptar pronósticos.",
    "erro desconhecido": "error desconocido",
    "esta rede não tem foto — o script cai para degradê": "esta red no tiene foto — el script recurre a degradado",
    "fixed": "fixed",
    "grey.200": "grey.200",
    "grey.400": "grey.400",
    "grey.500": "grey.500",
    "label": "label",
    "linear-gradient(90deg, #667eea, #764ba2)": "linear-gradient(90deg, #667eea, #764ba2)",
    "linear-gradient(90deg, #66bb6a, #43a047)": "linear-gradient(90deg, #66bb6a, #43a047)",
    "linear-gradient(90deg, #ef5350, #e53935)": "linear-gradient(90deg, #ef5350, #e53935)",
    "marca": "marca",
    "monospace": "monospace",
    "nenhum": "ninguno",
    "opacity 0.2s ease": "opacity 0.2s ease",
    "overwrite": "overwrite",
    "percentage": "percentage",
    "prefixed": "prefixed",
    "primary.main": "primary.main",
    "radar-pulse 2s ease-out 0.8s infinite": "radar-pulse 2s ease-out 0.8s infinite",
    "radar-pulse 2s ease-out infinite": "radar-pulse 2s ease-out infinite",
    "registro": "registro",
    "registros": "registros",
    "relative": "relative",
    "rgba(0, 0, 0, 0.6)": "rgba(0, 0, 0, 0.6)",
    "rgba(0,0,0,0.06)": "rgba(0,0,0,0.06)",
    "rgba(0,0,0,0.65)": "rgba(0,0,0,0.65)",
    "rgba(102, 126, 234, 0.08)": "rgba(102, 126, 234, 0.08)",
    "rgba(255,255,255,0.15)": "rgba(255,255,255,0.15)",
    "rgba(255,255,255,0.16)": "rgba(255,255,255,0.16)",
    "rgba(255,255,255,0.3)": "rgba(255,255,255,0.3)",
    "rgba(255,255,255,0.6)": "rgba(255,255,255,0.6)",
    "rgba(255,255,255,0.7)": "rgba(255,255,255,0.7)",
    "rgba(255,255,255,0.85)": "rgba(255,255,255,0.85)",
    "rgba(76,175,80,0.25)": "rgba(76,175,80,0.25)",
    "rgba(76,175,80,0.35)": "rgba(76,175,80,0.35)",
    "rodízio entre as viáveis": "rotación entre las viables",
    "rodízio entre os possíveis": "rotación entre los posibles",
    "rodízio entre os três": "rotación entre los tres",
    "rotate(-90deg)": "rotate(-90deg)",
    "rotate(0deg)": "rotate(0deg)",
    "scale(1.02)": "scale(1.02)",
    "skip": "skip",
    "transform 195ms cubic-bezier(0.4, 0, 0.6, 1)": "transform 195ms cubic-bezier(0.4, 0, 0.6, 1)",
    "use o formato #RRGGBB": "use el formato #RRGGBB",
    "valid": "valid",
    "validating": "validating",
    "video": "video",
    "warning.light": "warning.light",
    "weekly": "weekly",
    "width 0.4s ease": "width 0.4s ease",
    "zip": "zip",
};

export default catalogo;
